import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { isNil } from 'lodash';
import { Controller } from 'react-hook-form';
import type { Control, FieldValues, Path } from 'react-hook-form';

interface DatePickerElementProps<T extends FieldValues> {
  name: string;
  control: Control<T>;
  placeholder: string;
  timeBound?: 'start-of-day' | 'end-of-day';
}

export default function DatePickerElement<T extends FieldValues>({
  name,
  control,
  placeholder,
  timeBound,
}: DatePickerElementProps<T>): JSX.Element {
  return (
    <Controller
      name={name as Path<T>}
      control={control}
      render={({ field: { onChange, value, ...field }, fieldState: { error } }) => (
        <DatePicker
          {...field}
          value={!isNil(value) ? dayjs(value) : null}
          onChange={(newValue) => {
            if (newValue == null) {
              onChange(null);
              return;
            }
            const normalized =
              timeBound === 'start-of-day'
                ? newValue.startOf('day')
                : timeBound === 'end-of-day'
                ? newValue.endOf('day')
                : newValue;
            onChange(normalized.toDate());
          }}
          slotProps={{
            field: {
              clearable: true,
              onClear: () => {
                onChange(null);
              },
            },
            textField: {
              size: 'small',
              placeholder,
              error: !!error,
              helperText: error?.message,
            },
          }}
        />
      )}
    />
  );
}
